import { VpExternalLinkIcon, VpMaximizeIcon } from '@vtmn-play/icons/react';
import { VpIconButton } from '@vtmn-play/react';
import { useNavigate } from 'react-router-dom';
import { buildLegacyUrl } from '../../../utils/legacyUrl';

type RowActionsProps = {
  smId: string;
  startDate: string;
  endDate: string;
};

export const RowActions = ({ smId, startDate, endDate }: RowActionsProps) => {
  const navigate = useNavigate();

  return (
    <>
      <VpIconButton
        onClick={() =>
          navigate(`/personal-offer/my-view/sm?id=${smId}&offerDate=${endDate}`)
        }
        variant="tertiary"
        size="small"
        aria-label="Go to SM view"
        data-testid="go-SM_view"
      >
        <VpMaximizeIcon />
      </VpIconButton>
      <VpIconButton
        href={buildLegacyUrl(smId, startDate, endDate)}
        target="_blank"
        rel="noopener noreferrer"
        variant="tertiary"
        size="small"
        aria-label="Edit SM in Legacy"
        data-testid="edit-SM_legacy"
      >
        <VpExternalLinkIcon />
      </VpIconButton>
    </>
  );
};
